import { AppDispatcher } from 'services/PubSub';
import { actionsType } from 'config/constants';
import CartService from "services/Cart";
import ProductService from 'services/Product';
import PubSub from "services/PubSub";
import StorageService from 'services/StorageService';
import LoginService from 'services/Login';
import { urlPath } from 'config/index';

const factoryOrderForm = (orderForm) => {
    if (!orderForm) return Promise.resolve(orderForm);
    return ProductService.factoryOrderFormProducts(orderForm).then(orderForm => ProductService.getOrderFormProducts(orderForm));
};

let lostProductsOpened = false;

const _setLostProductsOpen = () => {
    lostProductsOpened = true;
}

const _setLostProductsClose = () => {
    lostProductsOpened = false;
}

PubSub.register('lost_products_open', _setLostProductsOpen);
PubSub.register('lost_products_close', _setLostProductsClose);

const _validateWithoutStock = (items) => {
    if(lostProductsOpened) return false;

    const itemsWithoutStock = (items && items.length) ? items.filter(item => item.availability === 'withoutStock') : [];
    
    if(itemsWithoutStock && itemsWithoutStock.length){
        const removeItems = itemsWithoutStock.map((item) => {
            return {
                id: item.id,
                seller: item.seller,
                quantity: item.quantity
            }
        })
        actions.removeMultiItems(removeItems).then(() => {
            setTimeout(() => {
                PubSub.dispatch('cart_products_open', { action: 'view', currentItems: removeItems, sc: 11,
                    title: 'Productos no disponibles',
                    message: '<span>Algunos productos ya no estan disponibles y <strong>fueron eliminados de tu carro.</strong></span>',
                    buttonSuccess: 'Entendido'
                });
            }, 0);
        });
    }
}

let timeout = null;
const dispatchOrderForm = (orderForm, type, optionalPayload = null) => {
    
    clearTimeout(timeout);
    timeout = setTimeout(() => _validateWithoutStock(orderForm && orderForm.items ? orderForm.items : []),100);
    
    

    return factoryOrderForm(orderForm).then(orderForm => {
        let payload = {
            orderForm: orderForm
        };

        if (optionalPayload) {
            payload = Object.assign(payload, optionalPayload);
        }

        AppDispatcher.dispatch({
            type,
            payload
        });

        actions.setLoading(false);

        setTimeout(() => {
            PubSub.dispatch('cart_update', { orderForm });
        }, 0);

        return orderForm;
    });
};

const getOrderInfoInCart = () => {
    const consults = [
        CartService.getOrderInfo(),
        actions.getCart()
    ];

    return Promise.all(consults).then(results => {
        const orderInfo = results[0];
        const orderForm = results[1];

        if (!(orderForm && orderForm.items && orderForm.items.length > 0)) return false;

        let skuData = {};

        orderForm.items.map(item => {
            skuData[item.id] = {};
        });

        if (orderInfo && orderInfo.skuData) {
            for (let key in orderInfo.skuData) {
                if (orderForm.items.findIndex(item => item.id == key) == -1){
                    delete skuData[key];
                }
                if (skuData[key]) {
                    skuData[key] = orderInfo.skuData[key];
                }
            }
        }
        return [orderInfo, skuData];
    });
};

const actions = {

    setLoading: (full, partial = false) => {
        AppDispatcher.dispatch({
            type: actionsType.CART_LOADING,
            payload: {
                loading: full,
                partialLoading: full || partial,
            }
        });
    },
    getCart: () => {
        actions.setLoading(true);
        return CartService.getCurrentCart().then(orderForm => dispatchOrderForm(orderForm, actionsType.GET_CART));
    },
    setCupon: (cupon) => {
        return CartService.setCupon(cupon).then(orderForm => dispatchOrderForm(orderForm, actionsType.SET_CUPON));
    },
    setUserReceiver: (receiverData) => {
        let body = {};

        if (receiverData) {
            body.receiverData = receiverData;
        }

        return CartService.setOrderInfo(body).then(result => {
            AppDispatcher.dispatch({
                type: actionsType.SET_RECEIVER_DATA,
                payload: body
            });

            return result;
        });
    },
    setPayment: (data) => {
        setTimeout(()=> actions.setLoading(true),0);
        return CartService.setPayment(data).then(orderForm => dispatchOrderForm(orderForm, actionsType.SET_PAYMENT));
    },
    addItems: (items) => {
        actions.setLoading(true);
        return CartService.addItems(items).then(orderForm => dispatchOrderForm(orderForm, actionsType.ADD_ITEM_CART));
    },
    updateOrderForm: (orderForm) => {
        return dispatchOrderForm(orderForm, actionsType.SET_SHIPPING_DATA);
    },
    updateShippingData: (address, logisticsInfo = null, method = null) => {
        let shippingData = {};
        actions.setLoading(true);
        if (logisticsInfo){
            if(method) {
                logisticsInfo = CartService.applyingMethodInLogisticInfo(logisticsInfo, method);
            }
            shippingData.logisticsInfo = CartService.clearLogisticInfo(logisticsInfo);
        }
        if (address)
            shippingData.address = address;

        return CartService.updateShippingData(shippingData).then(orderForm => {
            if(!orderForm){
                return false;
            }

            return dispatchOrderForm(orderForm, actionsType.SET_SHIPPING_DATA)
        })
    },
    removeMultiItems: (items) => {
        actions.setLoading(false, true);

        let replacementCriteriaLocal = StorageService.getItem('replacementCriteria');
        if (replacementCriteriaLocal) {
            replacementCriteriaLocal = JSON.parse(replacementCriteriaLocal);
            items.map((item) => {
                if (replacementCriteriaLocal[item.id]) {
                    delete replacementCriteriaLocal[item.id];
                    StorageService.setItem('replacementCriteria', JSON.stringify(replacementCriteriaLocal));
                }
            })
        }

        return CartService.removeItem(items).then(orderForm => dispatchOrderForm(orderForm, actionsType.REMOVE_ITEM_CART));
    },
    removeItem: (id, quantity) => {
        actions.setLoading(false, true);

        const optionalPayload = {
            removeElement: id
        };
        let replacementCriteriaLocal = StorageService.getItem('replacementCriteria');
        if (replacementCriteriaLocal) {
            replacementCriteriaLocal = JSON.parse(replacementCriteriaLocal);
            if (replacementCriteriaLocal[id]) {
                delete replacementCriteriaLocal[id];
                StorageService.setItem('replacementCriteria', JSON.stringify(replacementCriteriaLocal));
            }
        }
        return CartService.removeItem({
            id,
            quantity
        }).then(orderForm => dispatchOrderForm(orderForm, actionsType.REMOVE_ITEM_CART, optionalPayload));
    },
    updateItem: (id, oldQuantity, quantity) => {
        actions.setLoading(false, true);
        return CartService.updateQuantity({
            id,
            quantity: oldQuantity
        }, quantity).then(orderForm => dispatchOrderForm(orderForm, actionsType.UPDATE_CART));
    },
    clearCart: () => {
        actions.setLoading(true);
        return CartService.emptyCart().then(orderForm => dispatchOrderForm(orderForm, actionsType.CLEAR_CART));
    },

    cleanOrderForm: () => {
        actions.setLoading(true);

        return CartService.getCurrentCart().then(orderForm => {
            if(!orderForm) return false;
            const items = orderForm.items.map(item => {
                return {
                    id: item.id,
                    quantity: item.quantity
                }
            });

            return CartService.initOrderForm().then(() => {
                if(!(items && items.length)) return false;
                return actions.addItems(items);
            });
        });
    },
    logout: (redirect = () => { }) => {
        LoginService.logout();
        actions.cleanOrderForm().then(() => {
            if(redirect) redirect();
        });
    },
    logoutRedirect: () => {
        if(window && (window.location.href.indexOf('_secure') !== -1 || window.location.href.indexOf('/checkout') !== -1)){
            window.location.href = urlPath + '/';
        } else {
            PubSub.dispatch('user_logout');
            if(window) window.location.reload();
        }
    },
    getOrderInfo: () => {
        return getOrderInfoInCart().then((result) => {
            let bool = false;
            const orderInfo = result ? {...result[0]} : null;
            if(!orderInfo || !orderInfo.substituteType) {
                actions.setReplacementCriteriaAll(6);
                return false ;
            }

            const skuData = {...result[1]};

            for (let key in skuData) {
                if (!skuData[key] || !skuData[key].substituteType) {
                    bool = true;
                    skuData[key] = {
                        substituteType: 6
                    }

                }
            }

            if (bool) {
                actions.setOrderInfo(skuData, orderInfo.substituteType).then(() => {
                    AppDispatcher.dispatch({
                        type: actionsType.GET_ORDER_INFO, payload: {...orderInfo, skuData: skuData}
                    });
                });
            } else {
                AppDispatcher.dispatch({
                    type: actionsType.GET_ORDER_INFO,
                    payload: {...orderInfo, skuData: skuData}
                });
            }

            return orderInfo;
        });
    },

    setOrderInfo: (skuData, substituteType = false) => {
        let body = {
            skuData
        };

        if (substituteType) {
            body.substituteType = substituteType;
        }

        return CartService.setOrderInfo(body).then(result => {
            AppDispatcher.dispatch({
                type: actionsType.SET_ORDER_INFO,
                payload: body
            });
            return result;
        });
    },
    setReplacementCriteria: (id, substituteType, note = false, substituteTypeGlobal = false) => {
        let replacementCriteriaLocal = StorageService.getItem('replacementCriteria');
        StorageService.removeItem('deliveryExpressSelected');
        if (replacementCriteriaLocal) {
            replacementCriteriaLocal = JSON.parse(replacementCriteriaLocal);

            if (replacementCriteriaLocal[id]) {
                replacementCriteriaLocal[id].substituteType = substituteType;
            } else {
                replacementCriteriaLocal[id] = {
                    substituteType: substituteType
                }
            }
            if (note || note === '') {
                replacementCriteriaLocal[id].note = note;
            }
            StorageService.setItem('replacementCriteria', JSON.stringify(replacementCriteriaLocal));
            return actions.setOrderInfo(replacementCriteriaLocal, substituteTypeGlobal);

        } else {
            return getOrderInfoInCart().then(result => {
                const skuData = {...result[1]};
                if (skuData[id]) {
                    skuData[id].substituteType = substituteType;

                    if (note || note === '') {
                        skuData[id].note = note;
                    }
                }

                StorageService.setItem('replacementCriteria', JSON.stringify(skuData));
                actions.setOrderInfo(skuData, substituteTypeGlobal);
            });
        }
    },
    setReplacementCriteriaAll: (substituteType) => {
        let replacementCriteriaLocal = StorageService.getItem('replacementCriteria');
        StorageService.removeItem('deliveryExpressSelected');
        if (replacementCriteriaLocal) {
            replacementCriteriaLocal = JSON.parse(replacementCriteriaLocal);
            for (let id in replacementCriteriaLocal) {
                replacementCriteriaLocal[id].substituteType = substituteType;
            }

            StorageService.setItem('replacementCriteria', JSON.stringify(replacementCriteriaLocal));
            return actions.setOrderInfo(replacementCriteriaLocal, substituteType);

        } else {
            return getOrderInfoInCart().then(result => {
                const skuData = {...result[1]};
                for (let id in skuData) {
                    skuData[id].substituteType = substituteType;
                }

                StorageService.setItem('replacementCriteria', JSON.stringify(skuData));
                actions.setOrderInfo(skuData, substituteType);
            });
        }
    },
    setProfileData: (userProfile) => {
        return CartService.setClientProfile(userProfile).then(orderForm => dispatchOrderForm(orderForm, actionsType.SET_PROFILE_DATA));
    },

    createProfileData: (orderFormId) => {
        actions.setLoading(true);
        return LoginService.createProfileData(orderFormId).then(() => {
            return actions.getCart();
        });
    }

};

PubSub.register('cart_productAdd', (event) => {
    const { promise } = event.value;
    setTimeout(() => {
        actions.setLoading(false, true);
    }, 0);

    promise.then(orderForm => {
        if (!orderForm) {
            return false;
        }

        if (!(orderForm.items && orderForm.items[0]) && window) {
            window.orderItems = {};
        }

        dispatchOrderForm(orderForm, actionsType.ADD_ITEM_CART)
    });
});

export default actions;

